import { API_URLS, customAxios } from "../config";

export const startChatSession = payload => customAxios.post(API_URLS.startChatSession, payload).catch(ex => ({ data: { message: "Some error occured, Please try after sometime." } }));

// eslint-disable-next-line import/no-anonymous-default-export
export default { startChatSession };